module.exports = __webpack_public_path__ + "static/media/GPG600C_B01_SY.1640a2bd.jpg";